export const apiName: string = 'tipos-contatos';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/contatos/contato-tipos/shared/data.service.ts
 **/